import { useApiWithAuth } from '@/hooks/api';
import { useState } from 'react';
import { postComment as createComment } from '@/store/people/actions/comments';
import { Post } from '@/components/people/people/comments';
import type { Person } from '@/store/people/types';
import type { Comment } from '@/shared/types/comment';
import { DEFAULT_COMMENT_THREAD_ID } from '@/shared/types/comment';
import { Modal, ModalBody, ModalContent, ModalHeader } from '@/components/ui';
import { PersonItem } from '../common/output/person';
import { useModalSize } from '@/hooks/screen';
import { useUsersList } from '@/store/users/hooks';

export function CommentModal({
  isOpen,
  onOpenChange,
  subject,
}: {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  subject: Person | null;
}) {
  const { api, auth } = useApiWithAuth();
  const [posting, setPosting] = useState(false);
  const modalSize = useModalSize();
  const mentionUsers = useUsersList({});

  const postComment = ({ comment }: { comment: Comment }) => {
    setPosting(true);

    return createComment({ api, auth, comment })
      .then((result) => {
        onOpenChange(false);

        return result;
      })
      .finally(() => setPosting(false));
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      size={modalSize}
      placement='center'
      scrollBehavior='inside'
    >
      <ModalContent>
        <>
          <ModalHeader>Write a comment</ModalHeader>
          <ModalBody>
            {subject && (
              <>
                <PersonItem item={subject} className='mb-4' phone={false} />
                <Post
                  subject={subject}
                  threadId={DEFAULT_COMMENT_THREAD_ID}
                  posting={posting}
                  postComment={postComment}
                  className='mb-2'
                  users={mentionUsers}
                  canFlagSensitive={false}
                />
              </>
            )}
          </ModalBody>
        </>
      </ModalContent>
    </Modal>
  );
}
